import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="min-h-screen flex flex-col justify-between bg-white text-gray-800">
            {/* Header */}
            <header className="bg-gray-100 border-b">
                <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
                    <h1 className="text-lg font-semibold">ESTI</h1>
                    <a href="/" className="text-blue-600 hover:underline text-sm">← Басты бетке оралу</a>
                </div>
            </header>

            {/* Main Content */}
            <main className="flex-grow max-w-4xl mx-auto p-6">
                <h1 className="text-3xl font-bold mb-6">Құпиялылық саясаты</h1>

                <p className="mb-4">
                    Бұл құпиялылық саясаты <a href="https://esti.kz" className="text-blue-600 underline">https://esti.kz</a> веб-сайтының
                    пайдаланушыларынан қандай ақпараттар жинайтынын, оларды қалай қолданатынын және
                    қауіпсіз түрде сақтайтынын түсіндіреді.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">1. Жиналатын ақпарат</h2>
                <p className="mb-4">
                    Біз тек қажетті ақпаратты жинаймыз, оның ішінде:
                    <ul className="list-disc pl-6 mt-2">
                        <li>Құрылғы және браузер деректері</li>
                        <li>Қолданушының әрекеттері мен өзара байланысы</li>
                    </ul>
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">2. Ақпаратты пайдалану</h2>
                <p className="mb-4">
                    Жиналған ақпарат:
                    <ul className="list-disc pl-6 mt-2">
                        <li>Қызмет көрсету сапасын жақсарту</li>
                        <li>Қауіпсіздікті қамтамасыз ету</li>
                        <li>Қолданушы сұраныстарына жауап беру үшін</li>
                    </ul>
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">3. Ақпаратты бөлісу</h2>
                <p className="mb-4">
                    Сіздің ақпаратыңыз ешбір үшінші тараппен бөліспейміз, тек заң бойынша міндетті жағдайда немесе қауіпсіздік себептерімен ғана.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">4. Қауіпсіздік</h2>
                <p className="mb-4">
                    Деректеріңізді қорғау үшін заманауи техникалық және әкімшілік қауіпсіздік шараларын қолданамыз.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">5. Cookie файлдары</h2>
                <p className="mb-4">
                    Біздің сайт cookie файлдарын пайдаланады. Олар қолданушы тәжірибесін жақсартуға көмектеседі.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">6. Пайдаланушы құқықтары</h2>
                <p className="mb-4">
                    Сіз өзіңіздің деректеріңізді қарау, өзгерту немесе өшіру құқығына иесіз. Ол үшін төмендегі байланысқа жазыңыз.
                </p>

                <h2 className="text-xl font-semibold mt-6 mb-2">7. Байланыс</h2>
                <p className="mb-4">
                    Құпиялылық саясатына қатысты сұрақтарыңыз болса, бізге <a href="mailto:musaaldanazarov@gmail.com" className="text-blue-600 underline">musaaldanazarov@gmail.com</a> поштасы арқылы хабарласыңыз.
                </p>
            </main>

            {/* Footer */}
            <footer className="bg-gray-100 border-t mt-10">
                <div className="max-w-6xl mx-auto px-4 py-4 text-sm text-center text-gray-500">
                    © {new Date().getFullYear()} ESTI. Барлық құқықтар қорғалған.
                </div>
            </footer>
        </div>
    );
};

export default PrivacyPolicy;